import request from '@/utils/request'; // 服务名：ecargoaccount

export var BASE = '/api';
export var BASE_PATH = '/ecargoaccount'; // 获取列表

export function getData(data) {
  return request({
    url: '/ecargoaccount/credit/insurance',
    method: 'post',
    data: data
  });
} // 获取列表

export function queryInfo(data) {
  return request({
    url: '/ecargoaccount/credit/News',
    method: 'get',
    params: data
  });
} // 获取证件类型

export function getType() {
  return request({
    url: '/commondictionary/dictionary/queryByCodeType',
    method: 'post',
    data: {
      "codeType": "UserIdCard"
    }
  });
} // 编辑保存

export function editSave(data) {
  return request({
    url: '/ecargoaccount/credit/updateUserNews',
    method: 'post',
    data: data
  });
} // 新增用户

export function newUser(data) {
  return request({
    url: '/ecargoaccount/credit/AddUser',
    method: 'post',
    data: data
  });
} // 禁用用户

export function disable(data) {
  return request({
    url: '/ecargoaccount/credit/prohibitUser',
    method: 'get',
    params: data
  });
} // 获取列表

export function getPlatCustomers(data) {
  return request({
    url: '/ecargoaccount/user/getPlatCustomers',
    method: 'post',
    data: data
  });
} // 平台注册导出

export function customListExportDc(data) {
  return request({
    url: '/ecargoprotocol/protocolCommon/customListExportDc',
    method: 'post',
    data: data,
    responseType: 'blob'
  });
} // 平台保单管理-保单数据分页查询

export function getPlatformRegister(data) {
  return request({
    url: '/ecargoprotocol/protocolCommon/getPlatformRegister',
    method: 'post',
    data: data
  });
}